import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import templatesSlice from "./slices/templatesSlice";
import projectSlice from "./slices/projectSlice";
import authSlice from "./slices/authSlice";

const store = configureStore({
    reducer: {
        templates:templatesSlice,
        project:projectSlice,
        auth:authSlice
    },
});

store.subscribe(() => {
    const state = store.getState();
    const token = state.auth.token;
    if (token) {
        localStorage.setItem('authToken', token);
    } else {
        // localStorage.removeItem('authToken');
    }
});


export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;
